
import AppLedgerAccountCodeInput from "@/components/common/LedgerAccountCodeInput.vue";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { LedgerAccount, LedgerAccountBalans, LedgerAccountType, LedgerAccountVatField } from "@/models/ledger-account";
import { isStringNullOrWhitespace } from "@/utils/strings";
import AppSelectLedgerAccountVatField from "@/components/common/SelectLedgerAccountVatField.vue";
import AppErrorMessageBox from "@/components/common/ErrorMessageBox.vue";
import { TranslateResult } from "vue-i18n";
import { LedgerAccountService, DossierConfigService } from "@/services";
import LedgerAccountExtraFields from "@/models/ledger-account-extra-fields";
import { ExtraFieldNamesConfig } from "@/models/dossier-configs/extra-field-names-config";
import AppExtraFieldsEdit from "@/components/ExtraFieldsEdit.vue";


export default Vue.extend({
	data(){
		return {
			code: "",
			description: "",
			balans: LedgerAccountBalans.ACTIVE,
			groupCode: "",
			vatField: LedgerAccountVatField.NONE,
			ledgerType: LedgerAccountType.NONE,
			extraFields: new LedgerAccountExtraFields(),

			codeFocused: false,
			descriptionFocused: false,
			groupCodeFocused: false,
			allItems: [] as LedgerAccount[],
			DossierConfigService,
			tab: 0
		};
	},
	computed: {
		balansItems():ISelectItem<LedgerAccountBalans>[] {
			return [
				{
					text: this.$ct("models.LedgerAccount.passive"),
					value: LedgerAccountBalans.PASSIVE
				},
				{
					text: this.$ct("models.LedgerAccount.active"),
					value: LedgerAccountBalans.ACTIVE
				},
				{
					text: this.$ct("models.LedgerAccount.opbrengsten"),
					value: LedgerAccountBalans.OPBRENGSTEN
				},
				{
					text: this.$ct("models.LedgerAccount.costs"),
					value: LedgerAccountBalans.COSTS
				}
			];
		},
		typeItems():ISelectItem<LedgerAccountType>[] {
			return [
				{
					text: this.$ct("models.LedgerAccount.types.none"),
					value: LedgerAccountType.NONE
				},
				{
					text: this.$ct("models.LedgerAccount.types.clients"),
					value: LedgerAccountType.CLIENT
				},
				{
					text: this.$ct("models.LedgerAccount.types.suppliers"),
					value: LedgerAccountType.SUPPLIER
				}
			];
		},
		codeValid():boolean {
			return !this.shownLedgerAccountCodeErrorMessage;
		},
		shownLedgerAccountCodeErrorMessage():string | TranslateResult{
			if (!LedgerAccount.isValidCode(this.code)){
				return this.$ct("code-is-invalid");
			}
			if (this.allItems.find(i=>i.Code == this.code)){
				return this.$ct("code-already-exists");
			}
			return "";
		},
		accountCodeIsParentGroupCode():boolean {
			if (this.code.endsWith(".....")){
				return true;
			}
			return false;
		},
		groupCodeValid():boolean {
			if (this.groupCode == this.code) {
				return true;
			}
			if (this.accountCodeIsParentGroupCode && this.groupCode == "") {
				return true;
			}
			if (isStringNullOrWhitespace(this.groupCode)) {
				return false;
			}
			if (!this.code.startsWith(this.groupCode.replaceAll(".", ""))) {
				return false;
			}
			let foundGroup = this.allItems.find(i=>i.Code == this.groupCode);
			if (!foundGroup) {
				return false;
			}
			return true;
		},
		groupCodeItems():LedgerAccount[] {
			return this.allItems.filter(i=> i.isGroup() && i.Code.startsWith(this.groupCode) && this.code.startsWith(i.Code.replaceAll(".", "")));
		},
		descriptionValid():boolean {
			if (isStringNullOrWhitespace(this.description)) {
				return false;
			}
			return true;
		},
		isValid():boolean {
			return this.codeValid && this.groupCodeValid && this.descriptionValid;
		},
		extraFieldNames():ExtraFieldNamesConfig {
			return this.DossierConfigService.getExtraFieldNamesConfigs().LedgerAccountNames;
		},
		hasExtraFields():boolean{
			return this.extraFieldNames.hasActiveFields();
		},
		tabs():string[]{
			if (this.hasExtraFields){
				return [
					this.$ct("general").toString(),
					this.$ct("extra-fields").toString()
				];
			}
			return [];
		}
	},
	watch: {
		hasExtraFields(){
			if (!this.hasExtraFields) {
				this.tab = 0;
			}
		}
	},
	methods: {
		onGroupBlur(){
			this.groupCode = this.groupCode.trim();
			if (this.groupCode == "") return;
			let regex = new RegExp(`${this.groupCode.replaceAll(".", "")}\.+`);
			let foundItem = this.groupCodeItems.find(g=>regex.test(g.Code));
			if (!foundItem) {
				this.groupCode = "";
			}else{
				this.groupCode = foundItem.Code;
			}
		},
		onGroupClick(group:LedgerAccount){
			this.groupCode = group.Code;
		},
		async submit(){
			if (!this.isValid) return;
			let account = new LedgerAccount();
			account.Code = this.code;
			account.Description = this.description;
			account.Balans = this.balans;
			account.GroupCode = this.groupCode;
			account.VatField = this.vatField;
			account.ExtraFields = this.extraFields;
			await LedgerAccountService.createLedgerAccount(account);
			this.$emit("saved");
			this.$emit("close");
		},
		cancel(){
			this.$emit("close");
		}
	},
	async created(){
		this.allItems = await LedgerAccountService.fetchLedgerAccounts();
	},
	components: {
		AppLedgerAccountCodeInput,
		AppSelectLedgerAccountVatField,
		AppErrorMessageBox,
		AppExtraFieldsEdit
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
